import { render } from "./send-job-opportunity-email.vue?vue&type=template&id=7205fa88&scoped=true"
import script from "./send-job-opportunity-email.vue?vue&type=script&lang=js"
export * from "./send-job-opportunity-email.vue?vue&type=script&lang=js"

import "./send-job-opportunity-email.vue?vue&type=style&index=0&id=7205fa88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7205fa88"

export default script